import { Box, Button, Divider, Grid, List, ListItem, ListItemIcon, Typography } from '@mui/material';
import AppPresentation from '../../assets/acorn/acorn_app_presentation.png';
import AppPresentationTablet from '../../assets/acorn/acorn_app_presentation_tablet.png';
import AppPresentationMobile from '../../assets/acorn/acorn_app_presentation_mobile.png';
import AppStorePicture from '../../assets/acorn/icons/acorn_app_store.svg?react';
import PlayStorePicture from '../../assets/acorn/acorn_google_play.png';
import QRCodeSvg from '../../assets/acorn/icons/acorn_app_qr_code.svg?react';
import CheckIcon from '../../assets/acorn/icons/check_badge.svg?react';

const appStoresPictures = [
	{
		Component: AppStorePicture,
		alt: 'Download on the App Store',
		link: 'https://apps.apple.com/gb/app/acorn-taxi-insurance/id6474192338',
	},
	{
		src: PlayStorePicture,
		alt: 'Download on Google Play',
		link: 'https://play.google.com/store/apps/details?id=com.acorninsurance.taxi',
	},
];

const LOCAL_STORAGE_KEY = 'acorn-portal-communication-modal';

const AcornTaxiAppCommunication = () => {
	const handleClose = () => {
		window.open('https://www.acorninsure.co.uk/download-taxi-app');
		localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
	};

	return (
		<Box
			sx={{
				width: {
					xs: 328,
					sm: 398,
					md: 522,
					lg: 805,
				},
			}}
		>
			<Grid
				container
				direction={{ xs: 'column-reverse', lg: 'row' }}
				sx={{
					width: 'auto',
					margin: 0,
					padding: 0,
					display: 'flex',
					alignItems: 'center',
					textAlign: 'left',
				}}
			>
				<Grid
					size={{ xs: 12, md: 6 }}
					sx={{
						paddingLeft: '24px',
						paddingRight: '24px',
						paddingTop: '32px',
						paddingBottom: '32px',
					}}
				>
					<Box display='flex' flexDirection={'column'} mb={2}>
						<Typography
							variant='h5'
							sx={() => ({
								color: 'secondary.main',
								fontWeight: '700',
							})}
						>
							Our new Taxi app has launched!
						</Typography>
					</Box>
					<List>
						{[
							'View your policy documents',
							'Make changes to your policy',
							'Renew your cover',
							'Help to make a claim',
							'Access helpful FAQs and customer support',
						].map((text) => (
							<ListItem
								key={text}
								disablePadding
								sx={{
									margin: 0,
									padding: 0,
									display: 'flex',
									alignItems: 'center',
									gap: '8px',
									marginBottom: '12px',
								}}
							>
								<ListItemIcon
									sx={{
										minWidth: 20,
										p: 0,
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<CheckIcon />
								</ListItemIcon>
								<Typography variant='body2'>{text}</Typography>
							</ListItem>
						))}
					</List>
					<Box
						sx={{
							marginTop: '32px',
							marginBottom: '32px',
							display: { xs: 'none', lg: 'block' },
						}}
					>
						<Divider />
					</Box>
					<Box sx={{ margin: '20px 0' }} />

					<Box sx={{ display: { xs: 'flex', md: 'none' } }}>
						<Button fullWidth variant='contained' color='secondary' onClick={() => handleClose()}>
							GET THE APP
						</Button>
					</Box>
					<Box display='flex' alignItems='center' sx={{ display: { xs: 'none', md: 'flex' } }}>
						<Box
							sx={{
								marginRight: '16px',
								display: {
									xs: 'none',
									lg: 'flex',
								},
							}}
						>
							<QRCodeSvg style={{ width: '100%', height: 'auto' }} />
						</Box>

						<Box display='flex' gap={1} flexDirection={'column'}>
							<Typography
								variant='body1'
								sx={() => ({
									display: { xs: 'none', lg: 'flex' },
									textAlign: 'left',
									color: 'secondary.main',
									textWrap: 'balance',
									fontWeight: '700',
								})}
							>
								Scan the QR code to download the Acorn Taxi Insurance app
							</Typography>

							<Box flexDirection={'row'} display='flex' justifyContent='flex-start' gap={1}>
								{appStoresPictures.map(({ Component, src, alt, link }) => (
									<Box key={alt} component='a' href={link} target='_blank' rel='noopener noreferrer'>
										<Box
											sx={{
												width: 'auto',
												height: {
													xs: 42,
													sm: 42,
													md: 42,
													lg: 38,
												},
												display: 'block',
											}}
										>
											{Component ? (
												<Component style={{ height: '100%', width: 'auto' }} />
											) : (
												<Box component='img' src={src} alt={alt} sx={{ height: '100%', width: 'auto' }} />
											)}
										</Box>
									</Box>
								))}
							</Box>
						</Box>
					</Box>
				</Grid>

				<Box
					component={'picture'}
					sx={{
						display: 'block',
						width: '100%',
						mx: 'auto',
						marginRight: { lg: '-1px', md: 0 },
						maxWidth: {
							xs: 550,
							sm: 550,
							md: 550,
							lg: 382,
						},
					}}
				>
					<source media='(max-width: 600px)' srcSet={AppPresentationMobile} />
					<source media='(min-width: 601px) and (max-width: 1199px)' srcSet={AppPresentationTablet} />
					<Box
						component='img'
						src={AppPresentation}
						alt='Acorn App Screenshots'
						style={{ width: '100%', height: 'auto', display: 'block' }}
					/>
				</Box>
			</Grid>
		</Box>
	);
};

export default AcornTaxiAppCommunication;
